import { Injectable, Inject, InjectionToken, Optional } from '@angular/core';
import { AppConfig } from '../model/app-config';
import { environment } from '../../environments/environment';

export const APP_CONFIG: InjectionToken<AppConfig> = new InjectionToken<any>(
    'Application Configuration',
);

@Injectable()
export class AppConfigService {
    constructor(@Optional() @Inject(APP_CONFIG) private appConfig: AppConfig) {
        if (appConfig) {
            environment.cmsUri = appConfig.cmsUri;
            environment.apiUri = appConfig.apiUri;
            environment.production = appConfig.production;
            environment.addressServiceUri = appConfig.addressServiceUri;
            environment.allowLinksToCms = appConfig.allowLinksToCms;
            environment.analyticsSendToTagManager = appConfig.analyticsSendToTagManager;
            environment.analyticsUri = appConfig.analyticsUri;
            environment.identityUri = appConfig.identityUri;
            environment.isProdEnvironment = appConfig.isProdEnvironment;
            environment.aiConnectionString = appConfig.aiConnectionString;

            if (appConfig.isBackofficeEntryLink) {
                environment.identityUri = appConfig.backofficeIdentityUri;
            }
        }
    }
}
